// Headline stats per sport for career tiles, team cards and game logs.
// Values come from the backend (season totals; `avg` is computed server-side).
export const SPORT_TILES = {
  volleyball: [
    { key: 'kills', label: 'KILLS' },
    { key: 'assists', label: 'AST' },
    { key: 'blocks', label: 'BLK' },
    { key: 'digs', label: 'DIGS' },
    { key: 'aces', label: 'ACES' },
  ],
  soccer: [
    { key: 'goals', label: 'GOALS' },
    { key: 'assists', label: 'AST' },
    { key: 'shots', label: 'SHOTS' },
    { key: 'yellow_cards', label: 'YC' },
    { key: 'red_cards', label: 'RC' },
  ],
  netball: [
    { key: 'goals', label: 'GOALS' },
    { key: 'assists', label: 'AST' },
    { key: 'intercepts', label: 'INT' },
    { key: 'rebounds', label: 'REB' },
    { key: 'turnovers', label: 'TO' },
  ],
  flag_football: [
    { key: 'td', label: 'TD', name: 'Touchdowns' },
    { key: 'rec', label: 'REC', name: 'Catches' },
    { key: 'flag_pulls', label: 'FLAGS', name: 'Flag Pulls' },
    { key: 'int', label: 'INT', name: 'Interceptions' },
    { key: 'sacks', label: 'SACKS', name: 'Sacks' },
  ],
  softball: [
    { key: 'h', label: 'H', name: 'Hits' },
    { key: 'avg', label: 'AVG', name: 'AVG' },
    { key: 'hr', label: 'HR', name: 'HR' },
    { key: 'rbi', label: 'RBI', name: 'RBI' },
    { key: 'r', label: 'R', name: 'Runs' },
  ],
};
SPORT_TILES.baseball = SPORT_TILES.softball;
SPORT_TILES.cricket = [
  { key: 'runs', label: 'RUNS', name: 'Runs' },
  { key: 'wickets', label: 'WKTS', name: 'Wickets' },
  { key: 'sr', label: 'SR', name: 'Strike Rate' },
  { key: 'sixes', label: '6s', name: 'Sixes' },
  { key: 'catches', label: 'CT', name: 'Catches' },
];

// [stat key, label] used for the career trend chart.
export const SPORT_TREND = {
  volleyball: ['kills', 'Kills'],
  soccer: ['goals', 'Goals'],
  netball: ['goals', 'Goals'],
  flag_football: ['td', 'Touchdowns'],
  softball: ['h', 'Hits'],
  baseball: ['h', 'Hits'],
  cricket: ['runs', 'Runs'],
};

// Sports played on fields rather than courts.
export const FIELD_SPORTS = ['soccer', 'flag_football', 'softball', 'baseball', 'cricket'];

// Batting average style: 0.333 -> ".333", 1 -> "1.000"; strike rate to one decimal.
export function formatStat(key, value) {
  if (key === 'sr') return (Number(value) || 0).toFixed(1);
  if (key !== 'avg') return value ?? 0;
  const v = Number(value) || 0;
  return v >= 1 ? v.toFixed(3) : v.toFixed(3).replace(/^0/, '');
}

// Stats to enter for an event: optional ones only when switched on.
export const entryStats = (definition, advancedOn) =>
  (definition?.stats || []).filter((s) => advancedOn || !s.advanced);
